/**
 * Utility functions for downloading charts as images
 */

/**
 * Download SVG as PNG or JPG
 * @param {SVGElement} svgElement - The SVG element to download
 * @param {string} filename - Name of the file (without extension)
 * @param {string} format - 'png' or 'jpg'
 */
export const downloadChart = (svgElement, filename = 'chart', format = 'png') => {
  try {
    // Clone the SVG to avoid modifying the original
    const svgClone = svgElement.cloneNode(true);
    
    // Get SVG dimensions
    const bbox = svgElement.getBoundingClientRect();
    const width = bbox.width;
    const height = bbox.height;

    // Set explicit dimensions on clone
    svgClone.setAttribute('width', width);
    svgClone.setAttribute('height', height);

    // Serialize SVG to string
    const svgData = new XMLSerializer().serializeToString(svgClone);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);

    // Create image from SVG
    const img = new Image();
    img.onload = () => {
      // Create canvas
      const canvas = document.createElement('canvas');
      canvas.width = width * 2; // 2x for better quality
      canvas.height = height * 2;
      const ctx = canvas.getContext('2d');

      // White background for JPG
      if (format === 'jpg') {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      // Draw image on canvas (scaled up for quality)
      ctx.scale(2, 2);
      ctx.drawImage(img, 0, 0);

      // Convert to blob and download
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.${format}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        URL.revokeObjectURL(svgUrl);
      }, `image/${format === 'jpg' ? 'jpeg' : 'png'}`);
    };

    img.onerror = (error) => {
      console.error('Error loading SVG for download:', error);
      URL.revokeObjectURL(svgUrl);
    };

    img.src = svgUrl;
  } catch (error) {
    console.error('Error downloading chart:', error);
  }
};
